<template>
  <section class="is-widescreen">
    <div ref="title" class="description-bar">
      <p class="description-text">{{ descriptionText }}</p>
    </div>
    <div class="columns">
      <div ref="menu" class="column is-2 sidebar no-print">
        <aside class="menu">
          <!-- Firma -->
          <div class="company-header">
            <h3 class="company-name">{{ company }}</h3>
          </div>
          <!-- Administracija -->
          <p class="menu-section-label">Administracija</p>
          <div class="reports" v-for="report in actions" :key="report.reportId">
            <ul class="menu-list">
              <li>
                <a
                  class="menu-item"
                  :class="{ 'is-active': activeReportId === report.reportId }"
                  v-on:click="buttonClicked(report)"
                  @mouseover="descriptionText = report.description"
                  @mouseleave="descriptionText = '...'"
                >
                  {{ report.name }}
                </a>
              </li>
            </ul>
          </div>
          <!-- Izvještaji -->
          <p class="menu-section-label">Izvještaji</p>
          <div class="reports" v-for="report in reports" :key="report.reportId">
            <ul class="menu-list">
              <li>
                <a
                  class="menu-item"
                  :class="{ 'is-active': activeReportId === report.reportId }"
                  v-on:click="buttonClicked(report)"
                  @mouseover="descriptionText = report.description"
                  @mouseleave="descriptionText = '...'"
                >
                  {{ report.name }}
                </a>
              </li>
            </ul>
          </div>
          <!-- Specijalni izvještaji -->
          <p v-show="specialReports.length" class="menu-section-label">
            Specijalni izvještaji
          </p>
          <div
            class="reports"
            v-for="report in specialReports"
            :key="report.reportId"
          >
            <ul class="menu-list">
              <li>
                <a
                  class="menu-item"
                  :class="{ 'is-active': activeReportId === report.reportId }"
                  v-on:click="buttonClicked(report)"
                  @mouseover="descriptionText = report.description"
                  @mouseleave="descriptionText = '...'"
                >
                  {{ report.name }}
                </a>
              </li>
            </ul>
          </div>
          <!-- Generalno -->
          <p class="menu-section-label">Generalno</p>
          <ul class="menu-list">
            <li>
              <a
                class="menu-item"
                :class="{ 'is-active': activeReportId === 'about' }"
                @click="aboutButtonClick"
              >
                O programu
              </a>
            </li>
          </ul>
        </aside>
      </div>
      <div class="column main-view">
        <router-view />
      </div>
    </div>
  </section>
</template>

<script>
import UserService from "../../services/user.service";

export default {
  name: "User",
  data() {
    return {
      reports: [],
      specialReports: [],
      actions: [],
      errorMessage: "",
      descriptionText: "",
      company: "",
      activeReportId: null,
    };
  },
  mounted() {
    // First get user company
    UserService.getUserCompany().then(
      (response) => {
        console.log(response);
        this.company = response.data.name;
        this.$store.state.general.companyId = response.data.companyId;
        this.$store.state.general.companyName = response.data.name;
        this.descriptionText = this.company;
      },
      (error) => {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

    // Then get user content - sidebar buttons
    UserService.getUserContent().then(
      (response) => {
        console.log("reports:");
        console.log(response);
        let unsortedReports = [];
        let unsortedSpecialReports = [];
        let unsortedActions = [];
        response.data.forEach((element) => {
          // is it normal or special report?
          if (element.isSpecial === false) {
            unsortedReports.push({
              reportId: element.reportId,
              name: element.name,
              ordinal: element.ordinal,
              description: element.description,
              page: element.page,
              hover: false,
            });
          } else if (element.isSpecial === true) {
            unsortedSpecialReports.push({
              reportId: element.reportId,
              name: element.name,
              ordinal: element.ordinal,
              description: element.description,
              page: element.page,
              hover: false,
            });
          } else {
            unsortedActions.push({
              reportId: element.reportId,
              name: element.name,
              ordinal: element.ordinal,
              description: element.description,
              page: element.page,
              hover: false,
            });
          }
        });

        // Sort by ordinal
        this.reports = unsortedReports.sort(this.sortCompare);
        console.log("this.reports");
        console.log(this.reports);
        this.specialReports = unsortedSpecialReports.sort(this.sortCompare);
        this.actions = unsortedActions.sort(this.sortCompare);
      },
      (error) => {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
  methods: {
    sortCompare(a, b) {
      if (a.ordinal < b.ordinal) {
        return -1;
      }
      if (a.ordinal > b.ordinal) {
        return 1;
      }
      return 0;
    },
    buttonClicked(button) {
      console.log("clicked!" + button.name);
      console.log("Path: " + button.page);
      this.activeReportId = button.reportId;
      this.$router.push("/user/" + button.page);
      this.goto("title", "menu");
    },
    aboutButtonClick() {
      this.activeReportId = "about";
      this.$router.push("/user/about");
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    goto(refName1, refName2) {
      var element1 = this.$refs[refName1];
      var h1 = element1.clientHeight;
      var element2 = this.$refs[refName2];
      var h2 = element2.clientHeight;

      if (this.isMobile()) {
        window.scrollTo(0, h1 + h2 + 40);
        console.log(h1 + h2 + 40);
      }
    },
  },
};
</script>

<style scoped>
/* Description Bar */
.description-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 8px 16px;
}

.description-text {
  color: white;
  text-align: right;
  font-size: 13px;
  margin: 0;
  opacity: 0.9;
}

/* Sidebar */
.sidebar {
  background: linear-gradient(180deg, #1e293b 0%, #334155 100%);
  min-height: calc(100vh - 52px);
  padding: 0 !important;
}

.menu {
  position: sticky;
  vertical-align: top;
  max-height: 100vh;
  overflow-y: auto;
  top: 0;
  bottom: 0;
  padding: 16px 12px;
}

/* Company Header */
.company-header {
  padding: 16px 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.company-name {
  color: white;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  text-align: center;
}

/* Menu Section Labels */
.menu-section-label {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 12px 12px 8px 12px;
  margin: 0;
}

/* Menu List */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.reports {
  margin-bottom: 2px;
}

/* Menu Items */
.menu-item {
  display: block;
  padding: 10px 16px;
  color: #cbd5e1;
  font-size: 14px;
  text-decoration: none;
  border-radius: 8px;
  margin: 2px 8px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.menu-item.is-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

/* Main View */
.main-view {
  background-color: #f8fafc;
  min-height: calc(100vh - 52px);
  overflow-x: auto;
}

/* Large devices (laptops/desktops, 600px and up) */
@media only screen and (min-width: 600px) {
  .menu {
    position: sticky;
    vertical-align: top;
    overflow-y: auto;
    top: 0;
    bottom: 0;
    padding: 0px;
  }

  .main-view {
    overflow-x: scroll;
  }
}

.content {
  display: inline-block;
}

.pattern {
  background-color: #e5e5f7;
  opacity: 0.4;
  background-size: 22px 22px;
  background-image: repeating-linear-gradient(
    0deg,
    #a6a7bc,
    #a6a7bc 1.1px,
    #e5e5f7 1.1px,
    #e5e5f7
  );
}
</style>
